import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
  sendEmailVerification,
  fetchSignInMethodsForEmail,
  sendPasswordResetEmail,
  updateProfile,
} from "firebase/auth";

import { auth2 } from "../..//firebase";

import swal from "sweetalert";
// import ApiCountContext from "./ApiCountContext";

export const userAuthContext = createContext();

export function UserAuthContextProvider2({ children }) {
  const [isPaid, setIsPaid] = useState(false);

  useEffect(() => {
    window.sweet = swal;
    // dispatch(getWorkSpaceData());
  }, []);

  const logIn = async (email, password) => {
    try {
      const result = await fetchSignInMethodsForEmail(auth2, email);
      console.log(result);
      if (result && result.length > 0 && result[0].includes("google")) {
        return {
          error: "Please Signin with google",
        };
      } else {
        const userCred = await signInWithEmailAndPassword(
          auth2,
          email,
          password,
        );

        if (userCred.user.emailVerified) {
          return {
            user: userCred.user,
            error: "",
          };
        } else {
          signOut(auth2);
          return {
            error: "Please verify your email",
          };
        }
      }
    } catch (e) {
      return {
        error: e.message,
      };
    }
  };
  const signUp = async (name, email, password) => {
    try {
      const result = await fetchSignInMethodsForEmail(auth2, email);
      if (result && result.length > 0 && result[0].includes("google")) {
        return {
          error:
            "This email ID is already registerd with google, please sign in with google",
        };
      }
      const userCred = await createUserWithEmailAndPassword(
        auth2,
        email,
        password,
      );

      await updateProfile(auth2.currentUser, {
        displayName: name,
      });

      if (userCred.user) {
        sendEmailVerification(auth2.currentUser).then((result) => {
          console.log("Email verification sent");
        });
        console.log("Calling Window Gr function", {
          email: email,
          func: window.gr,
        });
        if (window.gr) window.gr("track", "conversion", { email: email });

        signOut(auth2);
        return {
          user: userCred.user,
        };
      }
    } catch (e) {
      return {
        error: e.message,
      };
    }
  };

  // for future use
  const resetPassword = async (email) => {
    try {
      sendPasswordResetEmail(auth2, email).then((result, err) => {
        if (err) {
          console.log(err);
        } else {
          console.log("Password Reset Email sent");
          console.log(result);
          window.sweet({
            title: "Email Sent",
            text: "Check your email for password reset link",
            icon: "success",
          });
        }
      });
    } catch (e) {
      return {
        error: e.message,
      };
    }
  };

  function logOut() {
    return signOut(auth2);
  }
  const googleSignIn = async (e, redirectAfterLogin) => {
    e.preventDefault();
    try {
      const googleAuthProvider = new GoogleAuthProvider();

      const userdetail = await signInWithPopup(auth2, googleAuthProvider);
      // console.log(userdetail.user.providerId);

      if (
        userdetail.user.metadata.createAt ===
        userdetail.user.metadata.lastLoginAt
      ) {
        if (window.gr)
          window.gr("track", "conversion", { email: userdetail.user.email });
      }

      localStorage.setItem("userid", userdetail.user.uid);
      redirectAfterLogin();
      // navigate('/backlinkvault');
    } catch (error) {}
  };

  useEffect(() => {
    onAuthStateChanged(auth2, async (currentuser) => {
      if (currentuser) {
        const token = await currentuser.getIdToken(true);
        localStorage.setItem("backlink_token", token);
        localStorage.setItem("email", currentuser.email);
        localStorage.setItem("name", currentuser.displayName);
        localStorage.setItem("imgurl", currentuser.photoURL);
        localStorage.setItem("userid", currentuser.uid);
        const paid = JSON.parse(currentuser.reloadUserInfo?.customAttributes);
        if (paid) setIsPaid(true);
      }
    });
  }, []);
  return (
    <userAuthContext.Provider
      value={{ logIn, signUp, logOut, googleSignIn, resetPassword, isPaid }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
